export enum Align {
  Left,
  Center,
  Right,
}
